import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth deve ser usado dentro de AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [empresaAtual, setEmpresaAtual] = useState(null);
  const [filialAtual, setFilialAtual] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const userData = sessionStorage.getItem('user');
    const empresaId = sessionStorage.getItem('empresaId');
    const filialId = sessionStorage.getItem('filialId');

    if (userData) {
      try {
        const parsedUser = JSON.parse(userData);
        setUser(parsedUser);

        const empresas = parsedUser.empresasVinculadas || [];
        if (empresaId && empresas.length) {
          const empresa = empresas.find((e) => e.id === parseInt(empresaId, 10));
          if (empresa) setEmpresaAtual(empresa);
        } else if (empresas.length === 1) {
          setEmpresaAtual(empresas[0]);
          sessionStorage.setItem('empresaId', empresas[0].id);
        }

        if (filialId) {
          setFilialAtual({ id: parseInt(filialId, 10) });
        }
      } catch (error) {
        sessionStorage.removeItem('user');
        sessionStorage.removeItem('empresaId');
        sessionStorage.removeItem('filialId');
      }
    }

    setLoading(false);
  }, []);

  /** userData deve ser o retorno normalizado de authenticate-with-empresas. */
  const login = (userData) => {
    setUser(userData);

    const empresas = userData.empresasVinculadas || [];
    const empresaSelecionada =
      userData.empresaSelecionada ||
      empresas.find((e) => e.id === userData.empresaSelecionadaId) ||
      (empresas.length === 1 ? empresas[0] : null);

    setEmpresaAtual(empresaSelecionada || null);
    setFilialAtual(null);

    sessionStorage.setItem('user', JSON.stringify(userData));
    if (empresaSelecionada) {
      sessionStorage.setItem('empresaId', empresaSelecionada.id);
    }
    sessionStorage.removeItem('filialId');
  };

  const selectEmpresa = (empresaId) => {
    const empresas = user?.empresasVinculadas || [];
    const empresa = empresas.find((e) => e.id === empresaId);
    if (empresa) {
      setEmpresaAtual(empresa);
      setFilialAtual(null);
      sessionStorage.setItem('empresaId', empresaId);
      sessionStorage.removeItem('filialId');
    }
  };

  /** filial: objeto retornado por GET /filiais, ou null para voltar à matriz. */
  const selectFilial = (filial) => {
    setFilialAtual(filial || null);
    if (filial) {
      sessionStorage.setItem('filialId', filial.id);
    } else {
      sessionStorage.removeItem('filialId');
    }
  };

  const logout = () => {
    setUser(null);
    setEmpresaAtual(null);
    setFilialAtual(null);
    sessionStorage.clear();
    localStorage.removeItem('token');
    localStorage.removeItem('tokendatahora');
  };

  const canSwitchEmpresa = () => (user?.empresasVinculadas?.length || 0) > 1;

  return (
    <AuthContext.Provider
      value={{
        user,
        empresaAtual,
        filialAtual,
        loading,
        login,
        logout,
        selectEmpresa,
        selectFilial,
        canSwitchEmpresa,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
